import axiosClient from "api/axiosClient";

const BASE_URL = "/User";

const userService = {
    forgotPassword(email) {
        return axiosClient.post(`${BASE_URL}/forgot-password`, {
            email
        });
    },
    validateResetToken(token) {
        return axiosClient.get(`${BASE_URL}/validate-reset-token/${token}`);
    },
    resetPassword(token, newPassword) {
        return axiosClient.post(`${BASE_URL}/reset-password`, {
            token,
            newPassword
        });
    }
};

export default userService;
